module.exports = __webpack_public_path__ + "static/media/phdiary.644e8087.ipynb";